<template>
    <div class="content" v-if="user">
        <div class="header">{{l10nProfileAndDigitalPurchases}}</div>
        <div class="divider"></div>
        <div class="main-area">
            <div class="profile">
                <form @submit.prevent="handleSubmit" novalidate>
                    <div class="personal-info profile-section">
                        <div class="personal-info-header">
                            <span>{{l10nPersonalInformation}}</span>
                            <span class="personal-info-edit" v-on:click="toggleEditMode()">
                            <font-awesome-icon :icon="['fal', 'pencil']"/>
                        </span>
                        </div>
                        <div class="profile-section-header-divider"></div>

                        <div class="personal-info-section personal-info-name">
                            <div class="personal-info-label personal-info-name-label">
                                <span>{{l10nName}}</span>
                            </div>
                            <div v-if="editMode">
                                <input class="personal-info-input" type="text" v-model="localUser.name" autofocus>
                            </div>
                            <div v-else class="personal-info-data personal-info-name-data">
                                <span>{{localUser.name}}</span>
                            </div>
                        </div>
                        <div class="personal-info-section personal-info-email">
                            <div class="personal-info-label personal-info-email-label">
                                <span>{{l10nEmail}}</span>
                            </div>
                            <div v-if="editMode">
                                <input class="personal-info-input" type="text" v-model="localUser.email">
                            </div>
                            <div v-else class="personal-info-data personal-info-email-data">
                                <span>{{localUser.email}}</span>
                            </div>
                        </div>
                        <div class="personal-info-section personal-info-telephone">
                            <div class="personal-info-label personal-info-telephone-label">
                                <span>{{l10nTelephone}}</span>
                            </div>
                            <div v-if="editMode">
                                <input class="personal-info-input" type="text" v-model="localUser.telephone">
                            </div>
                            <div v-else class="personal-info-data personal-info-email-data">
                                <span>{{localUser.telephone}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="shipping-info profile-section">
                        <div>
                            <div class="shipping-info-header">
                                <span>{{l10nShippingAddress}}</span>
                            </div>
                            <div class="profile-section-header-divider"></div>

                            <div class="shipping-info-container shipping-info-full-name">
                                <div class="shipping-info-label shipping-info-full-name-label">
                                    <span>{{l10nFullName}}</span>
                                </div>
                                <div class="shipping-info-full-name-input-container">
                                    <input class="shipping-info-input" type="text"
                                           v-model="localUser.shipping.fullName">
                                </div>
                            </div>
                            <div class="shipping-info-container shipping-info-country">
                                <div class="shipping-info-label shipping-info-country-label">
                                    <span>{{l10nCountry}}</span>
                                </div>
                                <div class="shipping-info-country-dropdown-container">
                                    <input class="shipping-info-input" type="text" v-model="localUser.shipping.country">
                                </div>
                            </div>
                            <div class="shipping-info-container shipping-info-address">
                                <div class="shipping-info-label shipping-info-address-label">
                                    <span>{{l10nAddress}}</span>
                                </div>
                                <div class="shipping-info-country-input-container">
                                    <input class="shipping-info-input" type="text" v-model="localUser.shipping.address">
                                </div>
                            </div>
                            <div class="shipping-info-container shipping-info-city">
                                <div class="shipping-info-label shipping-info-city-label">
                                    <span>{{l10nCity}}</span>
                                </div>
                                <div class="shipping-info-city-input-container">
                                    <input class="shipping-info-input" type="text" v-model="localUser.shipping.city">
                                </div>
                            </div>
                            <div class="shipping-info-container shipping-info-state-zip">
                                <div class="shipping-info-half-padder">
                                    <div class="shipping-info-state">
                                        <div class="shipping-info-label shipping-info-state-label">
                                            <span>{{l10nState}}</span>
                                        </div>
                                        <div class="shipping-info-state-input-container">
                                            <input class="shipping-info-half-input" type="text"
                                                   v-model="localUser.shipping.state">
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="shipping-info-zip">
                                        <div class="shipping-info-label shipping-info-zip-label">
                                            <span>{{l10nZipPostalCode}}</span>
                                        </div>
                                        <div class="shipping-info-state-input-container">
                                            <input class="shipping-info-half-input" type="text"
                                                   v-model="localUser.shipping.postalCode">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="submit-section">
                            <jabra-btn dark type="submit">
                                <span class="submit-btn-slot">{{l10nCompleteCheckout}}</span>
                            </jabra-btn>
                        </div>
                    </div>
                </form>
            </div>
            <div class="digital-purchases" v-if="purchases && purchases.length">
                <div v-for="(item, index) in purchases">
                    <div class="item-row" v-bind:class="{'top-space': index}">
                        <div class="description-section">
                            <div class="item-category">
                                <span>Digital Talmud</span>
                            </div>
                            <div class="item-name">
                                <span>Gittin</span>
                            </div>
                            <div class="item-id">
                                <span>7</span>
                            </div>
                        </div>
                        <div class="details-section">
                            <div>
                                <span class="download-date">Download: 1.2.18</span>
                                <span class="price">1.5 $</span>
                            </div>
                        </div>
                        <div class="download-section">
                            <jabra-btn>
                                <span class="download-btn-slot">Download</span>
                            </jabra-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../services/axios'
    import helpers from '../services/helpers'
    import lodash from '../services/lodash'

    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        UPDATE_USER,
        ADD_USER_ATTRIBUTES,
    } from '../services/constants'

    const LOCAL_USER_NAME = 'name'
    const LOCAL_USER_EMAIL = 'email'
    const LOCAL_USER_TELEPHONE = 'telephone'
    const LOCAL_USER_SHIPPING = 'shipping'
    const LOCAL_USER_SHIPPING_FULLNAME = 'fullName'
    const LOCAL_USER_SHIPPING_COUNTRY = 'country'
    const LOCAL_USER_SHIPPING_ADDRESS = 'address'
    const LOCAL_USER_SHIPPING_CITY = 'city'
    const LOCAL_USER_SHIPPING_STATE = 'state'
    const LOCAL_USER_SHIPPING_POSTAL_CODE = 'postalCode'
    const TYPE_TEXT_SHORT = 'text_short'
    export default {
        name: 'profile-component',
        data: function () {
            return {
                LOADING_PRISTINE: LOADING_PRISTINE,
                LOADING_STARTED: LOADING_STARTED,
                LOADING_COMPLETED_SUCCESS: LOADING_COMPLETED_SUCCESS,
                LOADING_COMPLETED_FAILURE: LOADING_COMPLETED_FAILURE,
                editMode: false,
                localUser: null,
                localUserTemplate: {
                    [LOCAL_USER_NAME]: '',
                    [LOCAL_USER_EMAIL]: '',
                    [LOCAL_USER_TELEPHONE]: '',
                    [LOCAL_USER_SHIPPING]: {
                        [LOCAL_USER_SHIPPING_FULLNAME]: '',
                        [LOCAL_USER_SHIPPING_COUNTRY]: '',
                        [LOCAL_USER_SHIPPING_ADDRESS]: '',
                        [LOCAL_USER_SHIPPING_CITY]: '',
                        [LOCAL_USER_SHIPPING_STATE]: '',
                        [LOCAL_USER_SHIPPING_POSTAL_CODE]: '',
                    },
                }
            }
        },
        computed: {
            user: function () {
                return this.$store.state.user.data
            },
            userAttributes: function () {
                return this.$store.state.userModule.attributes.data
            },
            purchases: function () {
                return []
            },
            l10nProfileAndDigitalPurchases() {
                return this.l10nGetter('profile_and_digital_purchases')
            },
            l10nPersonalInformation() {
                return this.l10nGetter('personal_information')
            },
            l10nName() {
                return this.l10nGetter('name')
            },
            l10nEmail() {
                return this.l10nGetter('email')
            },
            l10nTelephone() {
                return this.l10nGetter('telephone')
            },
            l10nShippingAddress() {
                return this.l10nGetter('shipping_address')
            },
            l10nFullName() {
                return this.l10nGetter('full_name')
            },
            l10nCountry() {
                return this.l10nGetter('country')
            },
            l10nAddress() {
                return this.l10nGetter('address')
            },
            l10nCity() {
                return this.l10nGetter('city')
            },
            l10nState() {
                return this.l10nGetter('state')
            },
            l10nZipPostalCode() {
                return this.l10nGetter('zip_postal_code')
            },
            l10nCompleteCheckout() {
                return this.l10nGetter('complete_checkout')
            },
        },
        watch: {
            '$route'(to, from) {
                this.update()
            },
            user(to, from) {
                if (to) {
                    if (to.emailAddress) {
                        this.localUser[LOCAL_USER_EMAIL] = to.emailAddress
                    }
                    if (to.firstName || to.lastName) {
                        this.localUser[LOCAL_USER_NAME] = ''
                    }
                    if (to.firstName) {
                        this.localUser[LOCAL_USER_NAME] += to.firstName
                    }
                    if (to.lastName) {
                        this.localUser[LOCAL_USER_NAME] += ' '
                        this.localUser[LOCAL_USER_NAME] += to.lastName
                    }
                }
            },
            userAttributes(to, from) {
                if (to) {
                    to.forEach(attribute => {
                        switch (attribute.key) {
                            case LOCAL_USER_TELEPHONE:
                                this.localUser[LOCAL_USER_TELEPHONE] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_FULLNAME:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_FULLNAME] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_COUNTRY:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_COUNTRY] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_ADDRESS:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_ADDRESS] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_CITY:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_CITY] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_STATE:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_STATE] = attribute.value
                                break
                            case LOCAL_USER_SHIPPING_POSTAL_CODE:
                                this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_POSTAL_CODE] = attribute.value
                                break
                            default:
                                break
                        }
                    })
                }
            },

        },
        methods: {
            toggleEditMode() {
                this.editMode = !this.editMode
            },
            update: function () {
                this.localUser = lodash.cloneDeep(this.localUserTemplate)
            },
            handleSubmit() {
                const nameArr = this.localUser.name.split(' ')
                const firstName = nameArr[0]
                const lastName = nameArr[nameArr.length - 1]
                const email = this.localUser.email;
                const updateUserPayload = {
                    firstName: firstName,
                    lastName: lastName,
                    emailAddress: email,
                }

                const updateUserAttributesPayload = []
                const preservedContext = this

                function pushToUserAttributesArray(key) {
                    updateUserAttributesPayload.push({
                        key: key,
                        value: key === LOCAL_USER_TELEPHONE ? preservedContext.localUser[key] : preservedContext.localUser[LOCAL_USER_SHIPPING][key],
                        type: TYPE_TEXT_SHORT
                    })
                }

                if (this.localUser[LOCAL_USER_TELEPHONE]) {
                    pushToUserAttributesArray(LOCAL_USER_TELEPHONE)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_FULLNAME]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_FULLNAME)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_COUNTRY]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_COUNTRY)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_ADDRESS]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_ADDRESS)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_CITY]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_CITY)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_STATE]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_STATE)
                }
                if (this.localUser[LOCAL_USER_SHIPPING][LOCAL_USER_SHIPPING_POSTAL_CODE]) {
                    pushToUserAttributesArray(LOCAL_USER_SHIPPING_POSTAL_CODE)
                }

                this.$store.dispatch(UPDATE_USER, updateUserPayload)
                this.$store.dispatch(ADD_USER_ATTRIBUTES, updateUserAttributesPayload)
            },
            getLessons: function () {
                this.shiurim = {
                    state: LOADING_STARTED,
                    data: [],
                    error: null,
                };
                const config = {
                    params: {
                        masechet: this.masechet.id,
                        language: this.$store.state.languageModule.currentLanguage.locale
                    }
                }
                http.getDelivery(`entries?contentType=lesson`, config).then(results => {
                    const mappedResults = results.data.map(entry => {
                        return helpers.mapEntry(entry)
                    })
                    mappedResults.sort(helpers.sortEntriesByFactory('number'))
                    this.shiurim = {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResults,
                        error: null,
                    };
                }).catch(err => {
                    console.log(err)
                    this.shiurim = {
                        state: LOADING_COMPLETED_FAILURE,
                        data: [],
                        error: err.message,
                    };
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created: function () {
            this.update()
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 245px 130px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .main-area {
        display: flex;
        width: 100%;
        margin: 46px 0 0 0;
    }

    .profile-section {
        background: $accent-2;
        @include font-abraham(30px, $font-color-blue, 300);
        padding: 33px 30px 13px 30px;
    }

    .personal-info-header {
        display: flex;
        justify-content: space-between;
    }

    .personal-info-section {
        margin: 35px 0;
    }

    .profile-section-header-divider {
        width: 120px;
        height: 8px;
        margin: 12px 0 0 0;
        background: $accent-1;
    }

    .personal-info-label {
        @include font-abraham(24px, $grey-1, 400);
    }

    .personal-info-data {
        @include font-abraham(24px, $font-color-blue, 400);
    }

    .personal-info-edit {
        color: $grey-1;
    }

    .profile {
    }

    .shipping-info {
        margin: 40px 0 0 0;
    }

    .shipping-info-label {
        @include font-abraham(18px, $font-color-blue, 300);
        margin: 0 0 15px 0;
    }

    .shipping-info-container {
        margin: 37px 0 0 0;
    }

    .shipping-info-state-zip {
        display: flex;
    }

    $form-input-width: 400px;
    $shipping-half-width-padding: 20px;
    $shipping-input-half-width: $form-input-width / 2 - $shipping-half-width-padding;

    .shipping-info-input, .personal-info-input {
        width: $form-input-width;
    }

    input {
        border: #cccccc solid 1px;
        line-height: 58px;
        transition: border-width 0.2s linear;
        &:focus {
            border-bottom-width: 4px;
        }
        color: $font-color-blue;

    }

    .shipping-info-half-padder {
        margin: 0 ($shipping-half-width-padding * 2) - 4px 0 0;
    }

    .shipping-info-half-input {
        width: $shipping-input-half-width;
    }

    .submit-section {
        display: flex;
        width: $form-input-width;
        justify-content: center;
        margin: 37px 0 25px 0;
    }

    .submit-btn-slot {
        @include font-abraham(20px, white, 400);
        line-height: 40px;
    }

    .digital-purchases {
        flex-grow: 1;
        margin: 0 0 0 22px;
    }

    .item-row {
        display: flex;
        width: 100%;
        border-left: $accent-1 solid 1px;
        box-shadow: 0px 7px 23.28px 0.72px rgba(0, 0, 0, 0.17);

        &.top-space {
            margin: 33px 0 0 0;
        }
    }

    .description-section {
        background: $accent-2;
        text-align: center;
        padding: 13px 73px 20px;
    }

    .item-category {
        @include font-abraham(18px, $font-color-blue, 400);
    }

    .item-name {
        @include font-abraham(30px, $font-color-blue, 400);
    }

    .item-id {
        @include font-abraham(22px, $font-color-blue, 400);
    }

    .details-section {
        display: flex;
        align-items: flex-end;
        flex-grow: 1;
        padding: 0 0 16px 0;
    }

    .download-date {
        @include font-abraham(16px, #959595, 400);
        margin: 0 20px;
    }

    .price {
        @include font-abraham(16px, $grey-1, 400);
    }

    .download-section {
        display: flex;
        align-items: center;
        padding: 0 30px;
    }

    .download-btn-slot {
        font-size: 20px;
        line-height: 40px;
    }

</style>
